import { Link, useLocation } from "react-router-dom";
import { FiArrowLeft, FiLock } from "react-icons/fi";

export default function UnauthorizedPage() {
  const location = useLocation();
  const from = location.state?.from;

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 via-white to-gray-50 flex items-center justify-center px-5">
      <div className="w-full max-w-lg rounded-3xl border border-gray-100 bg-white p-8 sm:p-10 text-center shadow-2xl shadow-primary-900/5">
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-primary-100 text-primary-800">
          <FiLock size={28} />
        </div>

        <p className="text-sm font-semibold uppercase tracking-[0.16em] text-primary-700">
          Access restricted
        </p>

        <h1 className="mt-3 text-3xl font-bold text-gray-900">
          You do not have access to this page.
        </h1>

        <p className="mt-4 text-sm leading-6 text-gray-500">
          Your account does not currently have the required permission. Please
          contact an administrator if you believe this is incorrect.
        </p>

        {from && (
          <p className="mt-4 break-all rounded-xl bg-gray-50 px-4 py-3 text-xs text-gray-400">
            Requested page: {from}
          </p>
        )}

        <Link
          to="/admindashboard"
          className="mt-8 inline-flex h-12 items-center justify-center gap-2 rounded-xl bg-primary-800 px-6 font-semibold text-white transition hover:bg-primary-900"
        >
          <FiArrowLeft size={18} />
          Back to dashboard
        </Link>
      </div>
    </div>
  );
}
